import React, { useState } from 'react';

const Login = ({ onLogin }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  // Credenciales por defecto (estas deberían venir de variables de entorno en producción)
  const validCredentials = {
    email: process.env.REACT_APP_LOGIN_EMAIL || 'admin@waengine.com',
    password: process.env.REACT_APP_LOGIN_PASSWORD || 'waengine2024'
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      // Enviar credenciales al backend para validación
      const response = await fetch('/api/auth/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: email,
          password: password
        })
      });

      const data = await response.json();

      if (response.ok && data.success) {
        // Login exitoso
        const userData = {
          email: data.user.email,
          name: data.user.name,
          role: data.user.role
        };
        
        localStorage.setItem('waengine_token', data.token);
        localStorage.setItem('waengine_user', JSON.stringify(userData));
        onLogin(userData);
      } else {
        // Login fallido
        setError(data.message || 'Credenciales incorrectas');
        setPassword('');
      }
    } catch (error) {
      console.error('Error en login:', error);
      setError('Error de conexión. Intenta de nuevo.');
    }
    
    setLoading(false);
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="text-center">
          <img 
            src="https://waengine.com/wp-content/uploads/WAEngine_logo_transparent_horiz-01.png" 
            alt="WAEngine" 
            title="WAEngine" 
            className="login-logo"
          />
          <h2 className="login-title">WAEngine API</h2>
          <p className="login-subtitle">
            Panel de Administración
          </p>
        </div>
        
        {error && (
          <div className="error-message" style={{ display: 'block' }}>
            {error}
          </div>
        )}
        
        <form onSubmit={handleSubmit}>
          <div className="login-field-group">
            <label className="login-field-label">Email:</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="login-field-input"
              placeholder="admin@waengine.com"
              required
              disabled={loading}
            />
          </div>
          
          <div className="login-field-group">
            <label className="login-field-label">Contraseña:</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="login-field-input"
              placeholder="••••••••"
              required
              disabled={loading}
            />
          </div>
          
          <div className="login-button-container">
            <button 
              type="submit" 
              className="login-submit-button"
              disabled={loading}
            >
              {loading ? (
                <>
                  <div className="spinner" style={{ width: '16px', height: '16px', marginRight: '8px' }}></div>
                  Verificando...
                </>
              ) : (
                <>
                  🔐 Iniciar Sesión
                </>
              )}
            </button>
          </div>
        </form>
        
        <div className="text-center mt-4">
          <small style={{ color: 'var(--waengine-text-muted)' }}>
            WAEngine API Manager | Acceso Seguro
          </small>
        </div>
      </div>
    </div>
  );
};

export default Login;

